// extracted by mini-css-extract-plugin
export default {"paginationContainer":"dataTable_paginationContainer__SuZR+","active":"dataTable_active__MEtpc"};